export var ONBOARDING_STATUS_VALUES;
(function (ONBOARDING_STATUS_VALUES) {
    ONBOARDING_STATUS_VALUES["COMPLETED"] = "completed";
    ONBOARDING_STATUS_VALUES["IN_PROGRESS"] = "in_progress";
})(ONBOARDING_STATUS_VALUES || (ONBOARDING_STATUS_VALUES = {}));
export const ONBOARDING_STATUS_VALUES_LIST = Object.values(ONBOARDING_STATUS_VALUES);
export var SETUP_WIZARD_FIELDS;
(function (SETUP_WIZARD_FIELDS) {
    SETUP_WIZARD_FIELDS["REIMBURSABLE_EXPENSE"] = "reimbursable_expense";
    SETUP_WIZARD_FIELDS["EMBURSE_CARDS"] = "emburse_cards";
    SETUP_WIZARD_FIELDS["CORPORATE_CARDS"] = "corporate_cards";
    SETUP_WIZARD_FIELDS["BUSINESS_CARDS"] = "business_cards";
    SETUP_WIZARD_FIELDS["MANUAL_CARD_FEED"] = "manual_card_feed";
    SETUP_WIZARD_FIELDS["AMEX_CARDS_TYPE"] = "amex_cards_type";
    SETUP_WIZARD_FIELDS["AMEX_VIRTUAL_CARDS"] = "amex_virtual_cards";
    SETUP_WIZARD_FIELDS["ACCOUNTING_INTEGRATION"] = "accounting_integration";
    SETUP_WIZARD_FIELDS["DESIRED_NUMBER_OF_USERS"] = "desired_number_of_users";
    SETUP_WIZARD_FIELDS["TARGET_LAUNCH_DATE"] = "target_launch_date";
})(SETUP_WIZARD_FIELDS || (SETUP_WIZARD_FIELDS = {}));
export const SETUP_WIZARD_FIELD_VALUES = Object.values(SETUP_WIZARD_FIELDS);
export var DESIRED_NUMBER_OF_USERS;
(function (DESIRED_NUMBER_OF_USERS) {
    DESIRED_NUMBER_OF_USERS["UNDER_10"] = "under_10";
    DESIRED_NUMBER_OF_USERS["FROM_11_TO_50"] = "11_to_50";
    DESIRED_NUMBER_OF_USERS["FROM_51_TO_100"] = "51_to_100";
    DESIRED_NUMBER_OF_USERS["FROM_101_PLUS"] = "101_plus";
})(DESIRED_NUMBER_OF_USERS || (DESIRED_NUMBER_OF_USERS = {}));
export const DESIRED_NUMBER_OF_USERS_VALUES = Object.values(DESIRED_NUMBER_OF_USERS);
export var TARGET_LAUNCH_DATE;
(function (TARGET_LAUNCH_DATE) {
    TARGET_LAUNCH_DATE["WITHIN_30_DAYS"] = "1";
    TARGET_LAUNCH_DATE["ONE_TO_TWO_MONTHS"] = "2";
    TARGET_LAUNCH_DATE["THREE_PLUS_MONTHS"] = "3";
})(TARGET_LAUNCH_DATE || (TARGET_LAUNCH_DATE = {}));
export const TARGET_LAUNCH_DATE_VALUES = Object.values(TARGET_LAUNCH_DATE);
export var AMEX_CARD_TYPE;
(function (AMEX_CARD_TYPE) {
    AMEX_CARD_TYPE["AMEX_CORPORATE_CARD"] = "amex_corporate_card";
    AMEX_CARD_TYPE["AMEX_BUSINESS_CARD"] = "amex_business_card";
})(AMEX_CARD_TYPE || (AMEX_CARD_TYPE = {}));
export const AMEX_CARD_TYPE_VALUES = Object.values(AMEX_CARD_TYPE);
export var WIZARD_VALUES;
(function (WIZARD_VALUES) {
    WIZARD_VALUES["YES"] = "yes";
    WIZARD_VALUES["NO"] = "no";
    WIZARD_VALUES["PENDING"] = "pending";
    WIZARD_VALUES["MAYBE"] = "maybe";
})(WIZARD_VALUES || (WIZARD_VALUES = {}));
export const WIZARD_VALUES_LIST = Object.values(WIZARD_VALUES);
export var ONBOARDING_CHECKLIST_FIELDS;
(function (ONBOARDING_CHECKLIST_FIELDS) {
    ONBOARDING_CHECKLIST_FIELDS["GUIDED_IMPLEMENTATION_SETUP"] = "guided_implementation_setup";
    ONBOARDING_CHECKLIST_FIELDS["GUIDED_IMPLEMENTATION_SETUP_COMPLETED_BY"] = "guided_implementation_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["WELCOME_GUIDED_IMPLEMENTATION_SETUP"] = "welcome_guided_implementation_setup";
    ONBOARDING_CHECKLIST_FIELDS["WELCOME_GUIDED_IMPLEMENTATION_SETUP_COMPLETED_BY"] = "welcome_guided_implementation_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["REIMBURSABLE_EXPENSES_SETUP"] = "reimbursable_expenses_setup";
    ONBOARDING_CHECKLIST_FIELDS["ATTEND_WEBINARS_SETUP"] = "attend_webinars_setup";
    ONBOARDING_CHECKLIST_FIELDS["ATTEND_WEBINARS_SETUP_COMPLETED_BY"] = "attend_webinars_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["BANK_ACCOUNT_SETUP"] = "bank_account_setup";
    ONBOARDING_CHECKLIST_FIELDS["REIMBURSABLE_EXPENSES_SETUP_COMPLETED_BY"] = "reimbursable_expenses_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["EMBURSE_CARDS_SETUP"] = "emburse_cards_setup";
    ONBOARDING_CHECKLIST_FIELDS["EMBURSE_CARDS_FUNDING_ACCOUNT_SETUP"] = "emburse_cards_funding_account_setup";
    ONBOARDING_CHECKLIST_FIELDS["EMBURSE_CARDS_FUNDS_SETUP"] = "emburse_cards_funds_setup";
    ONBOARDING_CHECKLIST_FIELDS["EMBURSE_CARDS_ISSUE_CARD_SETUP"] = "emburse_cards_issue_card_setup";
    ONBOARDING_CHECKLIST_FIELDS["EMBURSE_CARDS_SETUP_COMPLETED_BY"] = "emburse_cards_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["CARD_PROGRAM_SETUP"] = "card_program_setup";
    ONBOARDING_CHECKLIST_FIELDS["CARD_PROGRAM_SETUP_COMPLETED_BY"] = "card_program_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["ACCOUNTING_INTEGRATION_SETUP"] = "accounting_integration_setup";
    ONBOARDING_CHECKLIST_FIELDS["CATEGORIES_SETUP"] = "categories_setup";
    ONBOARDING_CHECKLIST_FIELDS["EXPENSE_FIELDS_SETUP"] = "expense_fields_setup";
    ONBOARDING_CHECKLIST_FIELDS["TEAM_FIELDS_SETUP"] = "team_fields_setup";
    ONBOARDING_CHECKLIST_FIELDS["ACCOUNTING_INTEGRATION_SETUP_COMPLETED_BY"] = "accounting_integration_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["POLICY_SETUP"] = "policy_setup";
    ONBOARDING_CHECKLIST_FIELDS["POLICY_SETUP_COMPLETED_BY"] = "policy_setup_completed_by";
    ONBOARDING_CHECKLIST_FIELDS["INVITE_USERS_SETUP"] = "invite_users_setup";
    ONBOARDING_CHECKLIST_FIELDS["INVITE_USERS_SETUP_COMPLETED_BY"] = "invite_users_setup_completed_by";
})(ONBOARDING_CHECKLIST_FIELDS || (ONBOARDING_CHECKLIST_FIELDS = {}));
export const ONBOARDING_CHECKLIST_FIELD_VALUES = Object.values(ONBOARDING_CHECKLIST_FIELDS);
export var ONBOARDING_CHECKLIST_VALUES;
(function (ONBOARDING_CHECKLIST_VALUES) {
    ONBOARDING_CHECKLIST_VALUES["COMPLETED"] = "completed";
    ONBOARDING_CHECKLIST_VALUES["PENDING"] = "pending";
    ONBOARDING_CHECKLIST_VALUES["SKIPPED"] = "skipped";
    ONBOARDING_CHECKLIST_VALUES["STARTED"] = "started";
    ONBOARDING_CHECKLIST_VALUES["DISMISSED"] = "dismissed"; // Needed for Guided Implementation to show that the user has dismissed the process
})(ONBOARDING_CHECKLIST_VALUES || (ONBOARDING_CHECKLIST_VALUES = {}));
export const ONBOARDING_CHECKLIST_VALUES_LIST = Object.values(ONBOARDING_CHECKLIST_VALUES);
export const ONBOARDING_CHECKLIST_INCOMPLETE_STATES = [ONBOARDING_CHECKLIST_VALUES.PENDING];
export const ONBOARDING_CHECKLIST_FIELDS_MAPPING = {
    reimbursable_expense: [ONBOARDING_CHECKLIST_FIELDS.REIMBURSABLE_EXPENSES_SETUP, ONBOARDING_CHECKLIST_FIELDS.BANK_ACCOUNT_SETUP],
    emburse_cards: [
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_FUNDING_ACCOUNT_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_FUNDS_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_ISSUE_CARD_SETUP
    ],
    corporate_cards: [ONBOARDING_CHECKLIST_FIELDS.CARD_PROGRAM_SETUP],
    business_cards: [ONBOARDING_CHECKLIST_FIELDS.CARD_PROGRAM_SETUP],
    manual_card_feed: [ONBOARDING_CHECKLIST_FIELDS.CARD_PROGRAM_SETUP],
    amex_cards_type: [ONBOARDING_CHECKLIST_FIELDS.CARD_PROGRAM_SETUP],
    amex_virtual_cards: [ONBOARDING_CHECKLIST_FIELDS.CARD_PROGRAM_SETUP],
    accounting_integration: [
        ONBOARDING_CHECKLIST_FIELDS.ACCOUNTING_INTEGRATION_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.CATEGORIES_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EXPENSE_FIELDS_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.TEAM_FIELDS_SETUP
    ],
    desired_number_of_users: [ONBOARDING_CHECKLIST_FIELDS.INVITE_USERS_SETUP],
    target_launch_date: []
};
export const ONBOARDING_CHECKLIST_MAIN_FIELDS = {
    REIMBURSABLE_EXPENSES_SETUP: [ONBOARDING_CHECKLIST_FIELDS.REIMBURSABLE_EXPENSES_SETUP, ONBOARDING_CHECKLIST_FIELDS.BANK_ACCOUNT_SETUP],
    EMBURSE_CARDS_SETUP: [
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_FUNDING_ACCOUNT_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_FUNDS_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EMBURSE_CARDS_ISSUE_CARD_SETUP
    ],
    CARD_PROGRAM_SETUP: [ONBOARDING_CHECKLIST_FIELDS.CARD_PROGRAM_SETUP],
    ACCOUNTING_INTEGRATION_SETUP: [
        ONBOARDING_CHECKLIST_FIELDS.ACCOUNTING_INTEGRATION_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.CATEGORIES_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.EXPENSE_FIELDS_SETUP,
        ONBOARDING_CHECKLIST_FIELDS.TEAM_FIELDS_SETUP
    ],
    POLICY_SETUP: [ONBOARDING_CHECKLIST_FIELDS.POLICY_SETUP],
    INVITE_USERS_SETUP: [ONBOARDING_CHECKLIST_FIELDS.INVITE_USERS_SETUP],
    ATTEND_WEBINARS_SETUP: [ONBOARDING_CHECKLIST_FIELDS.ATTEND_WEBINARS_SETUP],
    MISCELLANEOUS: [ONBOARDING_CHECKLIST_FIELDS.GUIDED_IMPLEMENTATION_SETUP, ONBOARDING_CHECKLIST_FIELDS.WELCOME_GUIDED_IMPLEMENTATION_SETUP]
};
